module.exports = __webpack_public_path__ + "img/banner_01.cc87719f.png";